import { Stack } from "@mui/material";
import { Card, Typography } from "@platform/design-system";

import { LaunchpadSection } from "../LaunchpadSection";

import type { GeneralSection } from "../../types";

interface Props {
  sections: readonly GeneralSection[];
}

/** What Rumi found outside any one line of coverage. */
const GeneralRfpData = ({ sections }: Props): React.JSX.Element => (
  <Card title="General RFP Data" variant="outlined" padding="condensed">
    <Stack spacing={1}>
      {sections.map((section) => (
        <LaunchpadSection
          key={section.id}
          data-testid={`launchpad-section-${section.id}`}
          title={section.title}
          state={section.state}
          metas={section.metas}
          link={section.link}
        >
          <Typography variant="body-medium">{section.finding}</Typography>
        </LaunchpadSection>
      ))}
    </Stack>
  </Card>
);

export { GeneralRfpData };
export type { Props as GeneralRfpDataProps };
